<template>
  <div
    class="order"
    style="
      padding: 0.49rem 0 0.5rem 0;
      height: 100%;
      background: rgb(243, 241, 244);
    "
  >
    <!-- tab页切换的标题部分 -->
    <ul class="order_title">
      <li
        class="all"
        :class="isActive == 1 ? 'active' : isActive == 2 ? 'inActiveRight' : ''"
        @click="orderListFn('', 1)"
      >
        全部
      </li>
      <li
        class="willPay"
        :class="isActive == 2 ? 'active' : isActive == 3 ? 'inActiveRight' : ''"
        @click="orderListFn(0, 2)"
      >
        待付款
      </li>
      <li
        :class="isActive == 3 ? 'active' : isActive == 4 ? 'inActiveRight' : ''"
        class="delivery"
        @click="orderListFn(1, 3)"
      >
        待发货
      </li>
      <li
        :class="isActive == 4 ? 'active' : ''"
        class="complete"
        @click="orderListFn(2, 4)"
      >
        已完成
      </li>
    </ul>
    <!-- 下面的订单列表部分 -->
    <div v-for="i in 4" :key="i" v-show="isActive == i">
      <van-list
        class="order_list"
        :style="{ background: finished[i - 1] ? 'none' : 'background:#fff' }"
        v-model="loading"
        :finished="finished[i - 1]"
        @load="onLoad(i - 2)"
        v-if="!isNone"
      >
        <li v-for="order in orderList[i - 1]" :key="order.id">
          <div @click="toCommodityDetail(order.shop_id)">
            <div class="order_list_title">
              <p>订单编号：EP{{ order.orderid }}</p>
              <div class="prompt" v-if="order.state == 0">等待付款</div>
              <div class="prompt" v-if="order.state == 1">等待发货</div>
              <div class="prompt" v-if="order.state == 2">已完成</div>
            </div>
            <div class="order_list_content">
              <img :src="order.shop_pic" alt="" />
              <div class="content_right" style="flex: 1">
                <h2>{{ order.title }}</h2>
                <div>
                  <p class="buyTime">下单时间：{{ order.ctime }}</p>
                  <div class="numMoney">
                    <p class="num">数量：x{{ order.num }}</p>
                    <p class="money">
                      金额：<span style="color: #93683d; font-size: 0.12rem"
                        >￥<span
                          style="font-weight: bold; font-size: 0.15rem"
                          >{{ order.price }}</span
                        ></span
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="order_list_btn">
            <van-button
              class="deleteBtn"
              plain
              type="defult"
              v-if="order.state == 0"
              @click="cancelOrder(order.orderid)"
              >取消订单</van-button
            >
            <van-button
              class="checkLogisticsBtn"
              plain
              type="defult"
              v-if="order.state == 2"
              @click="toLogistics(order.kuaidi)"
              >查看物流</van-button
            >
            <van-button
              class="payBtn"
              plain
              type="defult"
              v-if="order.state == 0"
              :to="{
                name: '在线支付',
                params: {
                  id: order.shop_id,
                  num: order.num,
                  title: order.title,
                  totalMoney: order.price,
                  orderId: order.orderid,
                },
              }"
              >立即支付</van-button
            >
          </div>
        </li>
      </van-list>
    </div>
    <!-- 当没有订单时 -->
    <div
      v-if="isNone"
      class="noOrder"
      style="
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #f3f1f4;
      "
      v-cloak
    >
      <img
        src="../../assets/img/empty/img_blank_order@2x.png"
        alt=""
        style="width: 2.17rem; height: 1.75rem; margin-top: 1.8rem"
      />
      <p
        style="
          height: 0.24rem;
          font-size: 0.12rem;
          color: #99999b;
          line-height: 0.24rem;
        "
      >
        还没有相关订单哦~
      </p>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { getOrderList, getOrderCancel } from '../../api/home'
export default {
  data () {
    return {
      isActive: 1,
      type: '',
      orderList: [],
      isNone: false,
      loading: false,
      finished: [false, false, false, false],
      // allpage: 1,
      // willpage: 1,
      // donepage: 1,
      // overpage: 1,
      page: [1, 2, 2, 2],
      toastLoading:null
    }
  },
  activated () {
    if (this.$route.params.activeNum) {
      if(this.orderList.length == 0)
      this.page[this.$route.params.activeNum[1] - 1] = 2
      this.finished[this.$route.params.activeNum[1] - 1] = false
      this.orderListFn(
        this.$route.params.activeNum[0],
        this.$route.params.activeNum[1]
      )
    } else {
      if (this.orderList.length != 0) {
        this.orderListFn(this.type, this.isActive)
        this.page[this.isActive - 1] = 2
        this.finished[this.isActive - 1] = false
        // console.log("不为空")
      }
    }
  },

  beforeRouteLeave (to, from, next) {
    if (to.name == '支付成功') {
      next('/home')
    } else {
      next()
    }
  },
  methods: {
    onLoad (val) {
      if(!this.toastLoading){
        this.loading = true
        let mytype
        val == -1 ? (mytype = '') : (mytype = val)
        getOrderList({ type: mytype, page: this.page[val + 1] })
          .then((res) => {
            this.page[val + 1] += 1
            if (this.orderList[this.isActive - 1]) {
              this.orderList[this.isActive - 1].push(...res.data.backdata.lists)
            } else {
              this.orderList[this.isActive - 1] = res.data.backdata.lists
            }
            if (this.orderList[this.isActive - 1].length == 0) {
              this.isNone = true
            } else {
              this.isNone = false
            }
            if (this.orderList[this.isActive - 1].length >= res.data.ext.total) {
              this.finished[val + 1] = true
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
          })
      }else{
            this.loading = false
      }
    },
    // 取消订单
    cancelOrder (val) {
      getOrderCancel({ orderid: val })
        .then((res) => {
          Toast(res.data.msg)
          if (res.data.code == 0) {
            this.orderListFn(this.type, this.isActive)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 跳往商品详情页
    toCommodityDetail (val) {
      this.$router.push({
        name: '商品详情',
        params: {
          id: val
          // activeNum: [this.type, this.isActive],
        }
      })
    },
    // 订单列表
    orderListFn (val, num) {
      if(!this.loading){
        this.type = val
        this.isActive = num
        if (!this.orderList[num - 1]) {
          this.toastLoading = this.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
          })
        }
        getOrderList({ type: val })
          .then((res) => {
            if (res.data.backdata.lists == 0) {
              this.isNone = true
            } else {
              this.isNone = false
            }
            this.orderList[num - 1] = res.data.backdata.lists
            this.$forceUpdate()
            if (this.toastLoading) {
              this.toastLoading.clear()
            }
          })
          .catch((err) => {
            if (this.toastLoading) {
              this.toastLoading.clear()
            }
          })
      }
    },
    toLogistics (kuaidi) {
      // console.log(kuaidi);
      window.location.href =
        'https://m.kuaidi100.com/app/query/?coname=weilairunmei&nu=' + kuaidi
    }
  }
}
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}
.order {
  // tab页切换的标题部分
  .order_title {
    width: 100%;
    height: 0.59rem;
    display: flex;
    padding: 0.15rem;
    background: #ffffff;
    position: fixed;
    z-index: 1;
    li {
      width: 0.86rem;
      height: 0.29rem;
      border: 1px solid #35353d;
      line-height: 0.29rem;
      text-align: center;

      font-size: 0.12rem;
      &.all {
        border-radius: 0.15rem 0rem 0rem 0.15rem;
      }
      &.willPay {
        border-left: none;
      }
      &.delivery {
        border-left: none;
      }
      &.complete {
        border-left: none;
        border-radius: 0rem 0.15rem 0.15rem 0rem;
      }
      &.active {
        background: linear-gradient(0deg, #dfb981 0%, hsl(37, 68%, 82%) 100%);
        border: 1px solid transparent;
        border-image: linear-gradient(0deg, #dfb981 0%, hsl(37, 68%, 82%) 100%);
        color: #93683d;
      }
      &.inActiveRight {
        border-right: none;
      }
      &.inActiveLeft {
        border-left: none;
      }
    }
  }
  // 下面的订单列表部分
  .order_list {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0.6rem;
    margin-bottom: 0.1rem;
    li {
      width: 3.45rem;
      // height: 2.07rem;
      background: #ffffff;
      border-radius: 0.08rem;
      margin-top: 0.11rem;
      padding: 0 0.15rem 0.12rem 0.15rem;
      .order_list_title {
        margin: 0.15rem 0;
        display: flex;
        justify-content: space-between;
        p {
          height: 0.12rem;
          font-size: 0.12rem;
          color: #999a9c;
          line-height: 0.12rem;
        }
        .prompt {
          height: 0.13rem;
          font-size: 0.12rem;
          color: #ff5d5d;
          line-height: 0.13rem;
        }
      }
      .order_list_content {
        margin-bottom: 0.26rem;
        display: flex;
        img {
          width: 0.88rem;
          height: 0.88rem;
          margin-right: 0.15rem;
        }
        .content_right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          h2 {
            width: 2.04rem;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 0.17rem;
            font-weight: bold;
            color: #333333;
            line-height: 0.2rem;
            margin-bottom: 0.13rem;
          }
          .buyTime {
            height: 0.12rem;
            font-size: 0.12rem;
            color: #999a9c;
            line-height: 0.12rem;
            margin-bottom: 0.11rem;
          }
          .numMoney {
            display: flex;
            justify-content: space-between;
            font-size: 0.12rem;
            color: #999a9c;
            line-height: 0.13rem;
          }
        }
      }
      .order_list_btn {
        display: flex;
        justify-content: flex-end;
        .van-button--normal {
          font-size: 0.14rem;
        }
        .deleteBtn {
          position: none;
          width: 0.93rem;
          height: 0.3rem;
          background: #ffffff;
          border: 1px solid #35353d;
          border-radius: 0.15rem;
          color: #35353d;
          margin-right: 0.13rem;
        }
        .checkLogisticsBtn {
          position: none;
          width: 0.93rem;
          height: 0.3rem;
          background: #ffffff;
          border: 1px solid #35353d;
          border-radius: 0.15rem;
          color: #35353d;
          margin-right: 0.13rem;
        }
        .payBtn {
          position: none;
          width: 0.93rem;
          height: 0.3rem;
          border: 1px solid #f0d8b1;
          background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
          border-radius: 0.15rem;
          color: #93683d;
        }
      }
    }
  }
}
</style>
